import {Container, Text} from '@inlet/react-pixi';
import {Rectangle} from '@gongxigames/framework/core/fragments/react';
import {ButtonWithTitle} from '../../components/ButtonWithTitle';
import React from 'react';

type SessionViewProps = {
    id: number;
    name: string;
    rounds: number;
    selected: boolean;
    width: number;
    onSelect: (id: number) => void;
    onDelete: (id: number) => void;
};

export function SessionView(props: SessionViewProps): JSX.Element {
    const {name, rounds, onSelect, onDelete, id, selected, width} = props;
    const textStyle = {fontSize: 80, fill: 0xffffff};
    const height = 150;
    const buttonHeight = height * 0.8;
    const fill = selected ? 0x000099 : 0x000000;

    return (
        <Container interactive={true} buttonMode={true} pointertap={() => onSelect(id)}>
            <Rectangle width={width} height={height} fill={fill} alpha={0.8}/>
            <Text x={20} y={height / 2} text={name} style={textStyle} anchor={[0, 0.5]}/>
            <Text x={width / 3} y={height / 2} text={rounds.toString()} style={textStyle} anchor={[0, 0.5]} />
            <ButtonWithTitle
                title={'delete'}
                fontSize={textStyle.fontSize}
                onClick={() => onDelete(id)}
                x={width - 320}
                y={height / 2 - buttonHeight / 2}
                width={200}
                height={buttonHeight}
            />
        </Container>
    );
}
